<!-- Skip to main content link for keyboard / screen reader accessibility -->
<a href="#main-content" class="skip-link">Skip to main content</a>

<app-top></app-top>
<div id="main-content" tabindex="-1">
  <router-outlet></router-outlet>
</div>

<footer class="site-footer">
  <div class="footer-content">
    <!-- Col 1: Visit Us -->
    <div class="footer-section">
      <h4>Visit Us</h4>
      <p class="footer-address">
        <mat-icon class="footer-icon">place</mat-icon>
        <a href="https://goo.gl/maps/ScmJEb1U5wZ97o9DA" target="_blank" rel="noopener noreferrer">
          Bayou Lacombe Museum<br>
          61115 S St. Mary Street<br>
          Lacombe, LA 70445
        </a>
      </p>
      <p class="footer-contact-links">
        <a href="tel:(985) 664-0256">
          <mat-icon class="footer-icon">phone</mat-icon>
          (985) 664-0256
        </a>
        <a href="mailto:info@bayoulacombemuseum.com">
          <mat-icon class="footer-icon">email</mat-icon>
          info&#64;bayoulacombemuseum.com
        </a>
      </p>
    </div>

    <!-- Col 2: Hours & Open Status -->
    <div class="footer-section">
      <h4>Hours</h4>
      <div class="status-indicator">
        <span class="status-dot" [class.open]="isOpenNow" [class.closed]="!isOpenNow"></span>
        <span class="status-text">
          {{ isOpenNow ? 'Open Now Until 4:00 PM' : 'Currently Closed' }}
        </span>
      </div>
      <p>
        <strong>General Public:</strong><br>
        Saturdays: Noon – 4:00 PM
      </p>
      <p>
        <strong>Private & Group Tours:</strong><br>
        Thu – Sat by appointment
      </p>
      <p class="admission-note">
        <small>Admission: $3 Adults &bull; $2 Seniors/Students &bull; Under 6 Free</small>
      </p>
    </div>

    <!-- Col 3: Explore -->
    <div class="footer-section">
      <h4>Explore</h4>
      <!-- Hidden for now
      <a routerLink="/tour">Self-Guided Audio Tour</a>
      <a routerLink="/timeline">Historical Timeline</a>
      -->
      <a routerLink="/exhibits">Museum Exhibits</a>
      <a routerLink="/events">Upcoming Events</a>
      <a routerLink="/past-events">Past Events Archive</a>
      <a routerLink="/gallery">Photo Gallery</a>
      <!-- Hidden for now
      <a routerLink="/shop">Museum Gift Store</a>
      -->
      <a routerLink="/about">Our Story & Mission</a>
    </div>

    <!-- Col 4: Get Involved -->
    <div class="footer-section">
      <h4>Get Involved</h4>
      <a routerLink="/donate">Make a Donation</a>
      <a routerLink="/memberships">Become a Member</a>
      <a routerLink="/volunteer">Volunteer With Us</a>
      <a routerLink="/appointment">Book a Group Tour</a>
      <a routerLink="/contact">Contact & Inquiries</a>
      <a href="https://www.facebook.com/Lacombemuseum/" class="social-link" target="_blank" rel="noopener noreferrer">
        Follow on Facebook
      </a>
    </div>
  </div>

  <div class="footer-bottom">
    <p>&copy; {{ year }} Bayou Lacombe Museum. All Rights Reserved. &bull; Historic 1912 Schoolhouse</p>
    <p>Powered by <a href="https://cypressbayoumedia.com/" target="_blank" rel="noopener noreferrer">Cypress Bayou Media</a></p>
  </div>
</footer>
<!-- Spacing for mobile bottom nav -->
<div style="height: 80px;"></div>
<app-bottom></app-bottom>